import ServiceTwo from '../ServiceTwo/ServiceTwo';

export default function SelectService() {
  return <ServiceTwo />;
}
